import styled from "styled-components";
import { accentColor, bodyTextRegular } from "../layout/style";

const StudyTrackerContainer = styled.div`
    position: absolute;
    top: 30px;
    left: 30px;

    padding: 5px;
    background: rgba(255,255,255,0.8);
    border-radius: 10px;

    display: flex;
    flex-direction: row;
    justify-content: space-evenly;

    ${bodyTextRegular}
`;

const StudyLabel = styled.div`
    flex: 1 0 auto;
    font-weight: 400;
    width: fit-content;
    color: #666666;
    font-size: 1.2rem;

    margin: 0px 10px;

    &.highlighted {
        font-weight: 700;
        color: #6b5305;
    }
`;

const VisDemoTracker = ({ whichStudy }) => {

    return <StudyTrackerContainer>
        <StudyLabel className={whichStudy === "Pressing" ? "highlighted" : ""}>Study 1</StudyLabel>
        <StudyLabel className={whichStudy === "Sway" ? "highlighted" : ""}>Study 2</StudyLabel>
        <StudyLabel className={whichStudy === "Shouldering" ? "highlighted" : ""}>Study 3</StudyLabel>
        <StudyLabel className={whichStudy === "Swooping" ? "highlighted" : ""}>Study 4</StudyLabel>
    </StudyTrackerContainer>


}

export default VisDemoTracker;